import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-analytics-power',
  templateUrl: './analytics-power.component.html',
  styleUrls: ['./analytics-power.component.sass']
})
export class AnalyticsPowerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
